module.exports = __webpack_public_path__ + "img/lifechamps-gear.d69533b9.svg";